import { GetAssetsResponse } from '@/lib/assets/types'
import { useEffect, useMemo } from 'react'
import { InfiniteData } from '@tanstack/query-core'
import { useFiltersStore } from '@/lib/store/filters-store'

/**
 * This hook is responsible to synchronize the filter keywords coming from the assets response infinite pagination.
 */
export default function useGetAssetResponseKeywords({ data }: { data?: InfiniteData<GetAssetsResponse | null> }) {
  const setAvailableKeywords = useFiltersStore((state) => state.setAvailableKeywords)

  const firstPage: GetAssetsResponse | null | undefined = useMemo(() => {
    if (!data || !data.pages) {
      return undefined
    }
    return data.pages[0]
  }, [data])

  // Register the available keywords. Take them form the first page response
  useEffect(() => {
    if (!firstPage) {
      return
    }

    const keywords = firstPage.meta?.tags

    if (!keywords) {
      return
    }

    setAvailableKeywords(keywords)
  }, [firstPage, setAvailableKeywords])

  return {
    firstPage,
  }
}
